const defaultState = {
    services: [],
}

const SET_SERVICES = "SET_SERVICES"

export const servicesReducer = (state = defaultState, action) => {
    switch (action.type) {
        case SET_SERVICES:
            return {...state, services: action.payload}

        default:
            return state
    }
}

export const setServicesAction = (payload) => ({type: SET_SERVICES, payload})
